<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { DropdownMenu, IconButton, Modal, SelectCard, CardGrid } from '@Shelly/shelly-design-system';
	import { SystemScreenBreakpoints } from '@Shelly/shelly-design-system/helpers/enums';
	import { format } from 'src/services/i18n';
	// @ts-ignore - MenuItemList exists but may not be in type definitions
	import { MenuItemList } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showDropdown: boolean = false;
	export let dropdownItems: {
		language: string;
		subtitle: string;
		title: string;
	}[];
	export let lang: string;
	export let selectedLang: string;

	const dispatch = createEventDispatcher();

	let windowClientWidth: number;
	let showModal = false;

	$: isMobileOrTablet = windowClientWidth <= SystemScreenBreakpoints.TABLET_MAX;

	const handleLanguageSelect = (menuItem: (typeof dropdownItems)[0]) => {
		dispatch('change-lang', menuItem);
		if (isMobileOrTablet) {
			showModal = false;
		} else {
			showDropdown = false;
		}
	};

	const handleTriggerClick = () => {
		if (isMobileOrTablet) {
			showModal = true;
		} else {
			showDropdown = !showDropdown;
		}
	};

	const closeModal = () => {
		showModal = false;
	};
</script>

<svelte:window bind:innerWidth={windowClientWidth} />

{#if isMobileOrTablet}
	<IconButton variant="label" on:click={handleTriggerClick}>
		{lang}
	</IconButton>

	<Modal bind:showModal on:close={closeModal} hideTitle>
		<svelte:fragment slot="content">
			<CardGrid md={250} noPaddingBottom gridGap="s" class="mt-s mb-s">
				{#each dropdownItems as menuItem}
					<SelectCard
						cardBgColor={$showNewLayout ? 'color-1' : undefined}
						hideAction
						type="horizontal"
						class="width-full"
						title={menuItem.title}
						selected={selectedLang === menuItem.language}
						on:click={() => handleLanguageSelect(menuItem)}
					/>
				{/each}
			</CardGrid>
		</svelte:fragment>
	</Modal>
{:else}
	<DropdownMenu bind:show={showDropdown}>
		<IconButton slot="trigger" variant="label" on:click={handleTriggerClick}>
			{lang}
		</IconButton>
		{#each dropdownItems as menuItem}
			<MenuItemList
				title={menuItem.title}
				isSelectable
				selected={selectedLang === menuItem.language}
				on:click={() => handleLanguageSelect(menuItem)}
			/>
		{/each}
	</DropdownMenu>
{/if}
